import CommonDataService from "../../common/data/CommonDataService";

export default CommonDataService("banks");
